import {
  normalizeAccount,
  ACCOUNT_DREAME,
  ACCOUNT_MEGELIN,
  MEGELIN_EID_SET,
  MEGELIN_UID_SET,
} from '../constants/accountOptions';
import { findEmployeeByUid, normalizeEmployeeId } from './qrHelpers';
import { formatAttendanceTime } from './timeHelpers';
import { getAttendanceRemarks } from './attendanceHelpers';

function isMegelinIdentity(eid, uid) {
  return MEGELIN_EID_SET.has(eid) || MEGELIN_UID_SET.has(uid);
}

export function getEmployeeAccount(employee) {
  if (!employee) return ACCOUNT_DREAME;

  const eid = normalizeEmployeeId(employee.eid);
  const uid = normalizeEmployeeId(employee.employeeId);
  if (isMegelinIdentity(eid, uid)) {
    return ACCOUNT_MEGELIN;
  }

  return normalizeAccount(employee.account);
}

export function resolveLogAccount(log, employees) {
  const logEid = normalizeEmployeeId(log?.eid);
  const logUid = normalizeEmployeeId(log?.employeeId);
  if (isMegelinIdentity(logEid, logUid)) {
    return ACCOUNT_MEGELIN;
  }

  const emp = findEmployeeByUid(employees, log?.employeeId);
  return getEmployeeAccount(emp);
}

export function parseLogDate(logDate) {
  if (!logDate) return null;
  const normalized = String(logDate).trim().replace(/\//g, '-');
  const parts = normalized.split('-');
  if (parts.length !== 3) return null;
  const [year, month, day] = parts.map((part) => part.padStart(2, '0'));
  const date = new Date(`${year}-${month}-${day}T12:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function filterAttendanceLogs(logs, employees, { startDate, endDate, account } = {}) {
  const accountFilter = account ? normalizeAccount(account) : null;

  return (logs || []).filter((log) => {
    if (accountFilter && resolveLogAccount(log, employees) !== accountFilter) return false;

    if (!startDate && !endDate) return true;

    const logDate = parseLogDate(log.date);
    if (!logDate) return false;
    if (startDate && logDate < new Date(`${startDate}T00:00:00`)) return false;
    if (endDate && logDate > new Date(`${endDate}T23:59:59`)) return false;
    return true;
  });
}

export function buildAttendanceExportRows(logs, employees) {
  return logs.map((log) => {
    const emp = findEmployeeByUid(employees, log.employeeId);
    const isOffDuty = log.timeOut && log.timeOut !== '' && log.timeOut !== '--:--';

    return {
      name: emp?.name || 'Unknown',
      uid: log.employeeId || '—',
      position: log.position || emp?.position || '—',
      date: log.date || '—',
      timeIn: formatAttendanceTime(log.timeIn, emp?.shift, 'in'),
      timeOut: formatAttendanceTime(log.timeOut, emp?.shift, 'out'),
      remarks: getAttendanceRemarks(log, emp) || '—',
      status: isOffDuty ? 'OFF-DUTY' : 'ON-DUTY',
      account: resolveLogAccount(log, employees),
    };
  });
}

export function formatExportDateRange(startDate, endDate) {
  if (startDate && endDate) return `${startDate} to ${endDate}`;
  if (startDate) return `From ${startDate}`;
  if (endDate) return `Until ${endDate}`;
  return 'All Dates';
}
